// The go-live legal pages (App.js routes them; public, no sign-in needed).
// Shared by the pages' own nav and the user menu so the two never drift.
export const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/refunds', label: 'Refunds' },
];
